import { COMPONENTRESOURCES, WizBasePopUp, WizDatasource, WizImage, WizPopUp } from '@wizeoo/akm-component-lib';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  ViewChild,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { first, Observable } from 'rxjs';
import { VALUE_ESCAPE, WizFileUtils } from '@wizeoo/akm-core-lib';
import { AttachmentService } from '../../../../command/core/attachment/attachment.service';
import { Model } from '../../../../model/model';
import { AiCmd } from '../../../../command/external/ai.cmd';
import { AiResponse } from '@wizeoo/akm-message-lib';

 export type zoomPopParams = {
  zoomPop: WizPopUp,
  blobid: string,
  blobList?: string[],
  callback?: Function // callback pour reconnaissance IA
 }


@Component({
  // zoom sur une image
  selector: 'zoom-pop',
  templateUrl: './zoom.pop.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ZoomPop extends WizBasePopUp implements AfterViewInit {

  // validation sur enter, sortie sur Esc
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
   
    if (event.key === VALUE_ESCAPE) {
      event.stopImmediatePropagation();
      event.preventDefault();
      this.hide();
    }
  } 

  @ViewChild('img', { read: WizImage, static: false }) img: WizImage;
  
  public get zoomParams(): zoomPopParams {
    return this.datas;
  }

  constructor(public elementRef: ElementRef, protected cdref: ChangeDetectorRef, private sanitizer: DomSanitizer) {
    super();
  }

  public imgSource: any = null;


  private _imgSrcObs: Observable<string> = null;
  public get imgSrcObs(): Observable<string> {
    if(!this._imgSrcObs) {
      this._imgSrcObs = AttachmentService.getInstance().downloadAttachmentForWidget(this.getMe(), false);
    }
    return this._imgSrcObs;
  }

  public get showNavigation(): boolean {
    return this.pool?.length > 1;
  }

  public get showOCR(): boolean {
    return !!this.zoomParams?.callback;
  }

  show(): void {
    // console.log('show zoom', this.zoomParams);
    if(this.zoomParams?.blobList) {
      this.pool = this.zoomParams.blobList;
      this.currentIdx = this.pool.indexOf(this.zoomParams.blobid);
    } else {
      this.pool = [this.zoomParams.blobid];
    }
    this._imgSrcObs = null;
    this.cdref.markForCheck();

    
    // this.sourceObservable = AttachmentService.getInstance().downloadAttachmentForWidget(this.datas, false);
    setTimeout(() => {
      if (!!this.img?.elementRef?.nativeElement) {
        this.img.elementRef.nativeElement.style.pointerEvents = 'auto';
      }
    }, 500);

  }

  /** annulation des modifs */
  public doCancel(): void {
    this.hide();
  }

  public onHide(): void {
    if(!!this.zoomParams && !!this.iaResult){
      this.zoomParams.callback(this.iaResult); 
    }
    
    super.onHide();
  }

  public getMe(): string {
    if(this.pool) {
      return this.pool[this.currentIdx];
    } else {
      return null;
    }
    
  }

  public pool: string[] = null;
  public currentIdx: number = 0;

  public go(way: number): void {
    this.currentIdx= this.currentIdx + way;
    if(this.currentIdx > this.pool.length - 1) {
      this.currentIdx = 0;
    } else if(this.currentIdx < 0) {
      this.currentIdx = this.pool.length - 1;
    }
    this._imgSrcObs = null;
    // TODO peut-être CDREF
  }


  private iaResult: any = null;

  public recognizeOCR(imgObs: Observable<string>): void {
    imgObs.pipe(first()).subscribe({
      next: (imgSrc: string) => {
        let q: string = "Analyse cette image. Si c'est un QRCODE ou un code barre, extrait un maximum d'informations. S'il y a du texte ,effectue une reconnaissance OCR. Retourne le résultat sous forme de liste de clés-valeurs, en JSON (ne l'encadre pas avec ```json)."
        let iacall: AiCmd = new AiCmd(Model.getInstance()).imageToText(q, imgSrc, this.backFromOCRCall.bind(this));
        iacall.execute();
      },
      error: (err) => {
        alert("Erreur lors de la récupération de l'image à OCR : " + err);
      }
    });
  }

  private backFromOCRCall(response: AiResponse): void {
    if(response?.response) {
      let j: any = JSON.parse(response.response);
      this.iaResult = WizFileUtils.jsonToPrettyText(j);
    }
    
    this.hide(); 
  }

}
